import type { z } from 'zod';

/** Parse with a schema and fail loudly with a readable message (CLAUDE.md §4.4). */
export function parseOrThrow<T>(schema: z.ZodType<T>, raw: unknown, what: string): T {
  const result = schema.safeParse(raw);
  if (result.success) return result.data;
  const detail = result.error.issues
    .map((i) => `  - ${i.path.join('.') || '(root)'}: ${i.message}`)
    .join('\n');
  throw new Error(`Invalid ${what}:\n${detail}`);
}
